export const getChargeMethod = (data) => {
    if (data.type === 'CARD') {
        return {
            type: 'CARD',
            brand: data.brand,
            last4Digits: data.last4Digits,
        };
    }
    if (data.type === 'PAYPAL') {
        return {
            type: 'PAYPAL',
            email: data.email,
        };
    }
    // UNKNOWN
    return {
        type: 'UNKNOWN',
    };
};
